import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2fb4275a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mapcontainer"
};
const _hoisted_2 = {
  key: 0,
  class: "logoWrap text"
};
const _hoisted_3 = {
  class: "logo_content"
};
const _hoisted_4 = {
  key: 1,
  class: "logoWrap"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "图例", -1));
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  id: "bdcontainer",
  class: "bdcontainer",
  ref: "bdcontainer"
};
const _hoisted_9 = {
  class: "popWrap"
};
const _hoisted_10 = {
  class: "funbox"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "banner"
};
const _hoisted_13 = {
  class: "swiper-container gallery-top"
};
const _hoisted_14 = {
  class: "swiper-wrapper",
  id: "bgImg"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "smallbox"
};
const _hoisted_17 = {
  class: "swiper-container gallery-thumbs"
};
const _hoisted_18 = {
  class: "swiper-wrapper",
  id: "smImg"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-button-next"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-button-prev"
}, null, -1));
const _hoisted_22 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.logo.type === 0 && $data.logo.text !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($data.logo.text), 1)])) : _createCommentVNode("", true), $data.logo.type === 1 && $data.logo.image !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.logo.image,
    alt: ""
  }, null, 8, _hoisted_5)])) : _createCommentVNode("", true), $data.legend.show ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "legendWrap",
    style: _normalizeStyle({
      backgroundImage: 'url(' + $data.legend.image + ')'
    })
  }, [_hoisted_6, _createElementVNode("ul", {
    style: _normalizeStyle({
      width: `${Math.ceil($data.teamtypeArr.length / 3) * 184 + 20}px`
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teamtypeArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
      src: $options.getImg(item[3][0].fileUrl),
      alt: ""
    }, null, 8, _hoisted_7), _createElementVNode("h4", null, _toDisplayString(item[2]), 1)]);
  }), 256))], 4)], 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, null, 512), _createVNode(_component_el_dialog, {
    modelValue: $data.popDialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.popDialog = $event),
    "modal-class": "starpop"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("h2", null, _toDisplayString($data.pdetail.name), 1), _createElementVNode("div", _hoisted_10, [$data.pdetail.team ? (_openBlock(), _createElementBlock("span", _hoisted_11, "所属团队：" + _toDisplayString($data.pdetail.team), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, "活动时间：" + _toDisplayString(`${$data.pdetail.time[0][0].val}`), 1)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pdetail.images, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "swiper-slide",
        key: index
      }, [_createElementVNode("img", {
        src: $options.getImg(item.fileUrl)
      }, null, 8, _hoisted_15)]);
    }), 128))])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pdetail.images, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "swiper-slide",
        key: index
      }, [_createElementVNode("img", {
        src: $options.getImg(item.fileUrl)
      }, null, 8, _hoisted_19)]);
    }), 128))])]), _hoisted_20, _hoisted_21])]), _createElementVNode("div", {
      class: "desc",
      innerHTML: $data.pdetail.introduce
    }, null, 8, _hoisted_22)])]),
    _: 1
  }, 8, ["modelValue"])]);
}